import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import SelectInput from './Select';
import moment from 'moment';
import PickCustomDateModal from './PickCustomDateModal';

import {
  withCombinedStyles,
  withComposedEnhancers
} from '../../../utils/hocUtils';
import { withNamespaces } from 'react-i18next';
import TypographyStyles from '../../../styles/typography';
import LayoutStyles from '../../../styles/layout';
import SpacingStyles from '../../../styles/helpers/spacing';
import ButtonStyles from '../../../styles/button';

const CUSTOM_DATE = 'pickCustomDate';

class DateRangeField extends Component {
  state = {
    openPickCustomDate: false
  };

  _handleChange = chg => {
    const {
      target: { name, value }
    } = chg;
    if (value === CUSTOM_DATE) {
      this.setState({ openPickCustomDate: name });
    } else {
      this.setState({ openPickCustomDate: null });
      const { onChange } = this.props;
      onChange(chg);
    }
  };

  _handleCustomDateClose = () => this.setState({ openPickCustomDate: null });

  render() {
    const { value, label, name, classes } = this.props;
    const t = s => s;
    return (
      <Fragment>
        <SelectInput
          native={false}
          name={name}
          // TODO: Make these options more configurable
          options={[
            { value: 'all', title: t('All') },
            { value: moment().format('YYYY-MM-DD'), title: 'Today' },
            {
              value: `${moment()
                .startOf('week')
                .format('YYYY-MM-DD')} - ${moment()
                .endOf('week')
                .format('YYYY-MM-DD')}`,
              title: t('This Week')
            },
            {
              value: `${moment()
                .startOf('month')
                .format('YYYY-MM-DD')} - ${moment()
                .endOf('month')
                .format('YYYY-MM-DD')}`,
              title: t('This Month')
            },
            { value: CUSTOM_DATE, title: t('Custom Date') }
          ]}
          defaultValue={value}
          classes={{
            root: classes.selectRoot
          }}
          inputLabel={label}
          onChange={this._handleChange}
        />
        {Boolean(this.state.openPickCustomDate) && (
          <PickCustomDateModal
            name={this.state.openPickCustomDate}
            onClose={this._handleCustomDateClose}
            onSave={this._handleChange}
            value={value}
          />
        )}
      </Fragment>
    );
  }
}

DateRangeField.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string
};

export default withComposedEnhancers(
  DateRangeField,
  withNamespaces(),
  withCombinedStyles(
    true,
    TypographyStyles,
    LayoutStyles,
    SpacingStyles,
    ButtonStyles
  )
);
